import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { Observable } from "rxjs";

@Injectable()
export class ContactService {
  constructor(private http: HttpClient) {}

  publicationSignup(email: string) {
    return this.http.post(`${environment.apiUrl}/publications/subscribe`, {
      email,
    });
  }

  userFormData(email: string, name: string, phone: string, message: string, company: string){
    return this.http.post(`${environment.apiUrl}/contacts/subscribe`, {
      email,
      name,
      phone,
      message,
      company

    });
  }
}
